import { render, staticRenderFns } from "./MembershipsMembers.vue?vue&type=template&id=5bc4105e"
import script from "./MembershipsMembers.vue?vue&type=script&lang=js"
export * from "./MembershipsMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports